/**
 * Log un message vers la console
 * @param {string} method
 * @param {any[]} attrs
 */
function log(method, ...attrs) {
  const prefix = `[${new Date().toISOString()}]${
    process?.pid ? `[PID:${process.pid}]` : ""
  }[${method}]`;
  console[method](prefix, ...attrs);
}

export function nextLogInfo(...attrs) {
  log("info", ...attrs);
}

export function nextLogError(...attrs) {
  log("error", ...attrs);
}

export function nextLogWarn(...attrs) {
  log("warn", ...attrs);
}

export function nextLogDebug(...attrs) {
  log("debug", ...attrs);
}
